import React from "react";
import { createRoot } from "react-dom/client";
import { MemoryRouter } from "react-router-dom";
import ToastProvider from "../components/shared/ToastProvider";
import SkillSheetMainCreateStepper from "../components/skill_sheet_main/pages/create/SkillSheetMainCreateStepper";
import { trackDemoEvent } from "../components/skill_sheet_main/utils/demoTracking";

// ======== プロジェクト入力フォームのデモ（TOPページ埋め込み） ========
// 未ログイン訪問者向けに、実際の skill_sheet_mains/new のステッパーを
// デモモードで動かす。マスタデータ取得は公開 autocomplete エンドポイントを使う
document.addEventListener("DOMContentLoaded", () => {
  // ファーストビューの「登録不要でデモ画面を試す」の計測
  document.querySelector(".demo_link_btn")?.addEventListener("click", () => {
    trackDemoEvent("demo_try_click");
  });

  const containers = document.querySelectorAll(".react-skill-sheet-main-demo");

  containers.forEach((container) => {
    if (!container || container.__reactRoot) return;

    container.__reactRoot = createRoot(container);
    container.__reactRoot.render(
      <React.StrictMode>
        <ToastProvider>
          <MemoryRouter>
            <SkillSheetMainCreateStepper demo />
          </MemoryRouter>
        </ToastProvider>
      </React.StrictMode>,
    );
  });
});
